/* ============================================================
   SHOWCASE — Horizontal Product Scroll
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  /* ── Init ───────────────────────────────────────────────────── */

  function initShowcase() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initShowcase, 100);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    setup();
  }

  function setup() {
    var showcase   = document.querySelector('.js-showcase');
    if (!showcase) return;

    var track      = showcase.querySelector('.js-showcase-track');
    var cards      = showcase.querySelectorAll('.js-showcase-card');
    var wash       = showcase.querySelector('.js-showcase-wash');
    var brandName  = document.querySelector('.js-brand-name');
    var siteHeader = document.querySelector('.js-site-header');

    if (!track || cards.length === 0) return;

    /* initial states */
    gsap.set(cards,    { opacity: 0, y: 24 });
    gsap.set(brandName, { opacity: 0, y: -6 });
    gsap.set(wash,     { opacity: 0 });

    /* ── Horizontal Scroll ──────────────────────────────────────── */

    var isMobile   = window.matchMedia('(max-width: 768px)').matches;
    var nVisible   = isMobile ? 1 : 3;
    var leadFrac   = 0.05;  /* dead zone before horizontal scroll starts */
    var scrollFrac = 1 - leadFrac;

    var getScrollDist = function () {
      return Math.max(0, track.scrollWidth - window.innerWidth);
    };

    /* Snap points shifted to account for lead-in */
    var totalSnaps = cards.length - nVisible;
    var snapPoints = [];
    for (var i = 0; i <= totalSnaps; i++) {
      snapPoints.push(leadFrac + scrollFrac * (i / totalSnaps));
    }

    /* Timeline: lead-in dead zone → horizontal scroll */
    var tl = gsap.timeline({ paused: true });
    tl.to({}, { duration: leadFrac, ease: 'none' });
    tl.to(track, {
      x:        function () { return -getScrollDist(); },
      ease:     'none',
      duration: scrollFrac,
    });

    ScrollTrigger.create({
      trigger:   showcase,
      pin:       true,
      scrub:     1.2,
      animation: tl,
      start:     'top top',
      end:       function () { return '+=' + (getScrollDist() / scrollFrac); },
      snap: {
        snapTo: function (value) {
          var nearest = snapPoints[0];
          snapPoints.forEach(function (p) {
            if (Math.abs(p - value) < Math.abs(nearest - value)) nearest = p;
          });
          return nearest;
        },
        duration: { min: 0.3, max: 0.6 },
        ease:     'power2.inOut',
        delay:    0.05,
      },
      onEnterBack: function () { enterLight(wash, brandName, siteHeader, null); },
      /* onLeave intentionally omitted — white persists after showcase */
      invalidateOnRefresh: true,
    });

    /* ── Reveal trigger — enter (downward) ─────────────────────── */

    ScrollTrigger.create({
      trigger: showcase,
      start:   'top top',
      onEnter: function () { enterLight(wash, brandName, siteHeader, cards); },
    });

    /* ── Reveal trigger — exit back (upward) ────────────────────── */
    /* Fires only after showcase has scrolled 15% of viewport height  */
    /* past the pin release, giving the first card a real buffer.     */

    ScrollTrigger.create({
      trigger:     showcase,
      start:       'top 15%',
      onLeaveBack: function () { exitLight(wash, brandName, siteHeader); },
    });

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
    document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }

  /* ── Light Mode Enter ───────────────────────────────────────── */

  function enterLight(wash, brandName, header, cards) {
    var siteWash = document.querySelector('.js-site-wash');
    var currentBrandName = document.querySelector('.js-brand-name') || brandName;
    var handoff  = siteWash && gsap.getProperty(siteWash, 'opacity') > 0.5;

    /* ── Step 1: Establish light background — no cards until this is done ── */

    gsap.killTweensOf(wash);

    if (handoff) {
      /* siteWash is already white — take over in the same frame, zero flash */
      gsap.set(wash, { opacity: 1 });
      gsap.killTweensOf(siteWash);
      gsap.set(siteWash, { opacity: 0 });
    } else {
      /* No handoff — kill any stray siteWash tween and fade showcase wash in */
      if (siteWash) { gsap.killTweensOf(siteWash); gsap.set(siteWash, { opacity: 0 }); }
      gsap.to(wash, { opacity: 1, duration: 0.25, ease: 'power2.out' });
    }

    /* ── Step 2: Flip header to light + reveal nav/cart ── */

    var currentHeader = document.querySelector('.js-site-header') || header;
    if (currentHeader) {
      currentHeader.classList.add('is-light');
      currentHeader.classList.add('is-scrolled');
    }

    /* ── Step 3: Brand name ── */

    if (currentBrandName) {
      gsap.killTweensOf(currentBrandName);
      gsap.to(currentBrandName, { opacity: 1, y: 0, duration: 0.4, delay: 0.05, ease: 'power2.out' });
    }

    /* ── Step 4: Cards — after light background is fully established ── */
    /* handoff: light is instant so 0.1s is enough;                      */
    /* normal:  wash takes 0.25s so cards start only after wash completes */

    if (cards && cards.length) {
      gsap.killTweensOf(cards);
      gsap.to(cards, {
        opacity:  1,
        y:        0,
        duration: 0.4,
        ease:     'power2.out',
        stagger:  0.04,
        delay:    handoff ? 0.1 : 0.25,
      });
    }
  }

  /* ── Light Mode Exit ────────────────────────────────────────── */

  function exitLight(wash, brandName, header) {
    gsap.killTweensOf(wash);
    gsap.to(wash, { opacity: 0, duration: 0.4, ease: 'power2.inOut' });
    var currentBrandName = document.querySelector('.js-brand-name') || brandName;

    /* Also kill and reset the site-wash so re-entry starts clean */
    var siteWash = document.querySelector('.js-site-wash');
    if (siteWash) {
      gsap.killTweensOf(siteWash);
      gsap.set(siteWash, { opacity: 0 });
    }

    var currentHeader = document.querySelector('.js-site-header') || header;
    if (currentHeader) {
      currentHeader.classList.remove('is-light');
      currentHeader.classList.remove('is-scrolled');
    }

    gsap.killTweensOf(currentBrandName);
    gsap.to(currentBrandName, { opacity: 0, y: -6, duration: 0.25, ease: 'power2.in' });

    /* Reset cards so next entry always animates from scratch */
    var allCards = document.querySelectorAll('.js-showcase-card');
    if (allCards.length) {
      gsap.killTweensOf(allCards);
      gsap.set(allCards, { opacity: 0, y: 24 });
    }

    /* Fade hero elements back in immediately — eliminates blank gap on reverse scroll */
    var hero = document.querySelector('.js-hero');
    if (hero) {
      var heroEls = [
        hero.querySelector('.js-bottle-left'),
        hero.querySelector('.js-bottle-right'),
        hero.querySelector('.js-hero-title'),
        hero.querySelector('.js-hero-card')
      ].filter(Boolean);
      if (heroEls.length) {
        gsap.killTweensOf(heroEls);
        gsap.to(heroEls, { opacity: 1, duration: 0.3, ease: 'power2.out' });
      }
    }
  }

  /* ── Boot ───────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowcase);
  } else {
    initShowcase();
  }

})();
